declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        GLightbox: CallableFunction;
    }
}


const register = (): void => {
    document.addEventListener("DOMContentLoaded", () => {
        const shareLinks = document.querySelectorAll("[data-share-url]");
        shareLinks.forEach((link) => {
            link.addEventListener("click", (event) => {
                event.preventDefault();
                const url = link.getAttribute("data-share-url");
                const title = link.getAttribute("data-share-title") || document.title;
                if (url) {
                    // if navigator share is available, use it, otherwise fallback to copying the link to clipboard
                    if (navigator.share) {
                        navigator
                            .share({
                                title: title,
                                url: url,
                            })
                            .catch((error) => console.error("Error sharing", error));
                    } else if (navigator.clipboard) {
                        navigator.clipboard
                            .writeText(url)
                            .then(() => {
                                alert(`Link copied to clipboard:\n\n${title}\n${url}`);
                            })
                            .catch((error) =>
                                console.error("Error copying to clipboard", error),
                            );
                    } else {
                        alert("Share not supported on this browser");
                    }
                }
            });
        });
    });
};

export { register };
